import React from 'react';
import style from './style.module.scss';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {Typography} from 'components/Typography';
import NextLink from 'next/link';

type TPropertiesProps = IProductSnippet['properties'];

export const Properties = (props: TPropertiesProps) => {
    const {list, onPropertyClick} = props;

    return (
        <>
            {list.map((property) => {
                return (
                    <NextLink
                        className={style.item}
                        key={property.code}
                        href={property.filterUrl ?? ''}
                        onClick={() => onPropertyClick(property.filterUrl ?? '')}
                    >
                        <Typography
                            variants={{
                                DT: 'snippet-description-14-r',
                                TB: 'snippet-description-12-r',
                                MB: 'snippet-description-12-r',
                            }}
                        >
                            {`${property.formattedValue.content}${property.formattedValue.suffix}`}
                        </Typography>
                    </NextLink>
                );
            })}
        </>
    );
};
